import { Router } from 'vue-router';

export default (router: Router) => {
  router.push('/Teacher/home');
};
